export default {"src":"/_next/static/media/TwoUsers.ddf04edd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};